import styles from 'components/icons/Icon.module.scss';
import { IconProps } from 'components/icons/Icons.types';
import React from 'react';

const TimeLapseIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          d="M11.9 16.1c-1.2 0-2.2-.5-3-1.2l3-3V7.7c2.3 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2Zm6.6-4.2c0 3.6-3 6.6-6.6 6.6s-6.6-3-6.6-6.6 3-6.6 6.6-6.6 6.6 3 6.6 6.6Zm-1.2 0c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4Z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default TimeLapseIcon;
